// src/pages/cobranzas/ItemsCobranzas.jsx
import React from 'react';

export const ItemsCobranzas2 = (props) => {
  const item = props.item || {};

  const safeNum = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };

  const safeDate = (d) => {
    if (!d) return '—';
    try { return new Date(d).toLocaleDateString('es-MX'); } catch { return '—'; }
  };

  const monto = safeNum(item.MontoParcial);
  const tasa = safeNum(item.TasadelDia);

  return (
    <tr>
      <td className="text-danger fw-bold">{item.DocumentoFormaPago ?? '—'}</td>
      <td>{item.FormaPago === 'tr' ? 'Transferencia' : 'Efectivo'}</td>
      <td>{item.BancoPago ?? '—'}</td>
      <td>{safeDate(item.FechaPago)}</td>
      <td className="text-success fw-bold">
        {(tasa > 0) ? 'Bs. ' : '$'}{monto.toFixed(2)}
      </td>
      <td className="text-danger fw-bold">{item.Recibo ?? '—'}</td>
      <td className="text-success fw-bold">Bs. {tasa}</td>
    </tr>
  );
};

